import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlayFill = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	id: "svg1",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { id: "defs1" }), /* @__PURE__ */ _jsx("path", {
		id: "path2",
		d: "M 9.4140625,4 C 7.8396524,4.0237187 6.514031,5.08608 6.2695312,6.9550781 c -0.3559996,3.1589969 -0.3639996,6.5431289 0,10.0781249 0.2989998,2.397998 2.3384369,3.593765 4.7714848,2.634766 2.858997,-1.151999 5.456158,-2.845518 7.535156,-4.728516 1.919998,-1.764998 1.875998,-4.179908 0,-5.8789061 C 16.380174,7.0495489 13.856013,5.4850301 11.041016,4.3320312 10.491254,4.1005315 9.9388659,3.9920938 9.4140625,4 Z"
	})]
});
export default SvgPlayFill;
